module.exports = __webpack_public_path__ + "static/itsm_capabilities_9-82ef1fb5d854f4c39e0a9173238c98f2.png";